'use strict';

const { waitForElement } = require('./util');

function getQuoteMediaImgSrc(symbol, width, height, env) {
    const params = {
        webmasterId: '104239',
        chcon: 'off',
        chfrmon: 'off',
        chbgch: 'ffffff',
        chbg: 'ffffff',
        chgrd: 'cccccc',
        chbdr: 'cccccc',
        chxyc: '333333',
        chln: '0f79b6',
        chdon: 'off',
        chfill: '0f79b6',
        chfill2: 'ffffff',
        symbol: symbol,
        chscale: '1d',
        chton: 'off',
        chwid: width,
        chhig: height,
        chtype: 'Mountain',
        chlowwh: '10',
        chfnts: '10',
        svg: 'true',
        lang: 'en',
        chtcol: 'cccccc',
        disableSid: 'false',
        a2accessibility: 'false',
        locale: 'en',
    };

    const paramsStr = Object.keys(params)
        .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

    return `https://${env}.quotemedia.com/quotetools/getChart?${paramsStr}`;
}

function loadQuoteMediaTool(rootElement, toolId) {
    const loadTool = () => {
        const toolElement = rootElement?.querySelector?.(`#${toolId}`);
        if (!toolElement) {
            return;
        }

        window.qMod.loadTool(toolId);
    };

    waitForElement(document, '#qmod').then((scriptElement) => {
        if (!window.qMod) {
            scriptElement.addEventListener('load', loadTool);
            return;
        }

        loadTool();
    });
}

module.exports = {
    getQuoteMediaImgSrc,
    loadQuoteMediaTool,
};
